import {useContext, useEffect, useState} from 'react';
import Logo from '../../src/assets/images/BX-LOGO.svg'
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {NavLink, useNavigate} from "react-router-dom";
import AuthContext from "../context/AuthContext";
import Avatar from "react-avatar";
import {useQuery} from "@tanstack/react-query";
import {getMerchantKYCIndiaInfo} from "../api/api";

const kycStatusConfig = {
    PENDING: {
        label: "KYC Pending",
        badgeClassName: "badge badge-light-warning",
    },
    SUBMITTED: {
        label: "KYC Submitted",
        badgeClassName: "badge badge-light-info",
    },
    "UNDER-PROCESS": {
        label: "KYC Under Process",
        badgeClassName: "badge badge-light-primary",
    },
    VERIFIED: {
        label: "KYC Verified",
        badgeClassName: "badge badge-light-success",
    },
    REJECTED: {
        label: "KYC Rejected",
        badgeClassName: "badge badge-light-danger",
    },
};

function Navbar() {
    let {user, logout} = useContext(AuthContext)
    // const { status, data } = useAuth(true, () => {
    //     if(status==='success'){
    //         setUser(data?.results[0])
    //     }
    // })
    const navigate = useNavigate()

    const [navDropdownOpen, setNavDropdownOpen] = useState(false);
    const toggleNavDropdown = () => setNavDropdownOpen(!navDropdownOpen);

    const [sidebarToggle , setSidebarToggle] = useState(false);

    const [profilePicture, setProfilePicture] = useState(user?.['basic-info']?.profile_picture);

    const { data: kycData } = useQuery({
        queryKey: ['merchant-kyc-india-navbar'],
        queryFn: () => getMerchantKYCIndiaInfo(),
        keepPreviousData: true,
        retry: false,
        enabled: !!user,
    });

    useEffect(() => {
        // Prioritize merchant KYC India profile picture, fallback to basic-info profile picture
        if (kycData?.results?.[0]?.profile_picture) {
            setProfilePicture(kycData.results[0].profile_picture);
        } else if (user?.['basic-info']?.profile_picture) {
            setProfilePicture(user['basic-info'].profile_picture);
        }
    }, [user, kycData]);

    const handleSidebarToggle =()=>{
        if(!sidebarToggle){
            document.body.classList.add("sidebar-enable");
            document.body.classList.add("enlarged");
        }else{
            document.body.classList.remove("sidebar-enable");
            document.body.classList.remove("enlarged");
        }
        setSidebarToggle(!sidebarToggle);
    };

    const handleLogout = (e) => {
        e?.preventDefault();
        logout({message: 'Logged Out!'})
    }

    const handleMyAccount = () => {
        navigate('/account')
    }

    const handleSettings = () => {
        navigate('/settings')
    }

    const handleBilling = () => {
        navigate('/billing')
    }

    const kycStatusDetails = kycStatusConfig[user?.kyc_status] || {
        label: user?.kyc_status || "KYC Unknown",
        badgeClassName: "badge badge-light-secondary",
    };

    return (
        <div className="navbar-custom">
            <ul className="list-unstyled topnav-menu float-right ">


                {/*<li className="dropdown notification-list">*/}
                {/*    <a className="nav-link dropdown-toggle  waves-effect waves-light" data-toggle="dropdown" href="#"*/}
                {/*       role="button" aria-haspopup="false" aria-expanded="false">*/}
                {/*        <i className="fe-bell noti-icon"/>*/}
                {/*        <span className="badge badge-danger rounded-circle noti-icon-badge">4</span>*/}
                {/*    </a>*/}
                {/*    <div className="dropdown-menu dropdown-menu-right dropdown-lg">*/}

                {/*        <div className="dropdown-item noti-title">*/}
                {/*            <h5 className="m-0">*/}
                {/*                    <span className="float-right">*/}
                {/*                        <a href="" className="text-dark">*/}
                {/*                            <small>Clear All</small>*/}
                {/*                        </a>*/}
                {/*                    </span>Notification*/}
                {/*            </h5>*/}
                {/*        </div>*/}

                {/*        <div className="slimscroll noti-scroll">*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item active">*/}
                {/*                <div className="notify-icon bg-soft-primary text-primary">*/}
                {/*                    <i className="mdi mdi-comment-account-outline"></i>*/}
                {/*                </div>*/}
                {/*                <p className="notify-details">Doug Dukes commented on Admin Dashboard*/}
                {/*                    <small className="text-muted">1 min ago</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item">*/}
                {/*                <div className="notify-icon">*/}
                {/*                    <img src="assets/images/users/avatar-2.jpg" className="img-fluid rounded-circle"*/}
                {/*                         alt=""/></div>*/}
                {/*                <p className="notify-details">Mario Drummond</p>*/}
                {/*                <p className="text-muted mb-0 user-msg">*/}
                {/*                    <small>Hi, How are you? What about our next meeting</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item">*/}
                {/*                <div className="notify-icon">*/}
                {/*                    <img src="assets/images/users/avatar-4.jpg" className="img-fluid rounded-circle"*/}
                {/*                         alt=""/></div>*/}
                {/*                <p className="notify-details">Karen Robinson</p>*/}
                {/*                <p className="text-muted mb-0 user-msg">*/}
                {/*                    <small>Wow ! this admin looks good and awesome design</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item">*/}
                {/*                <div className="notify-icon bg-soft-warning text-warning">*/}
                {/*                    <i className="mdi mdi-account-plus"></i>*/}
                {/*                </div>*/}
                {/*                <p className="notify-details">New user registered.*/}
                {/*                    <small className="text-muted">5 hours ago</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item">*/}
                {/*                <div className="notify-icon bg-info">*/}
                {/*                    <i className="mdi mdi-comment-account-outline"></i>*/}
                {/*                </div>*/}
                {/*                <p className="notify-details">Caleb Flakelar commented on Admin*/}
                {/*                    <small className="text-muted">4 days ago</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}


                {/*            <a href="javascript:void(0);" className="dropdown-item notify-item">*/}
                {/*                <div className="notify-icon bg-secondary">*/}
                {/*                    <i className="mdi mdi-heart"></i>*/}
                {/*                </div>*/}
                {/*                <p className="notify-details">Carlos Crouch liked*/}
                {/*                    <b>Admin</b>*/}
                {/*                    <small className="text-muted">13 days ago</small>*/}
                {/*                </p>*/}
                {/*            </a>*/}
                {/*        </div>*/}

                {/*        <a href="javascript:void(0);"*/}
                {/*           className="dropdown-item text-center text-primary notify-item notify-all">*/}
                {/*            View all*/}
                {/*            <i className="fi-arrow-right"/>*/}
                {/*        </a>*/}

                {/*    </div>*/}
                {/*</li>*/}

                {/*<li className="dropdown notification-list">*/}
                {/*    <a className="nav-link dropdown-toggle nav-user mr-0 waves-effect waves-light"*/}
                {/*       data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">*/}
                {/*        <img src={Logo} alt="user-image" className="rounded-circle"/>*/}
                {/*            <span className="pro-user-name ml-1">*/}
                {/*                Nik Patel <i className="mdi mdi-chevron-down"/>*/}
                {/*            </span>*/}
                {/*    </a>*/}
                {/*</li>*/}

                <Dropdown nav isOpen={navDropdownOpen} toggle={toggleNavDropdown} className="notification-list">
                    <DropdownToggle nav caret aria-haspopup={false} className="nav-user mr-2 waves-effect waves-light">
                        {profilePicture ? (
                            <img
                                src={profilePicture}
                                alt="user-profile"
                                className="rounded-circle profile-click"
                            />
                        ) : (
                            <Avatar
                                size={30}
                                name={user.first_name}
                                round
                            />
                        )}
                        <span className="pro-user-name ml-1 profile-click">
                            {user && user.first_name} <i className="mdi mdi-chevron-down" />
                        </span>
                    </DropdownToggle>

                    <DropdownMenu className="dropdown-menu-right profile-dropdown menu-dropdown">

                        <DropdownItem className="noti-title" header>
                            {/*{status === 'success' && (*/}
                            {/*    <p className="text-overflow m-0">Welcome {data.results[0].first_name}!</p>*/}
                            {/*)}*/}
                            <p className="text-overflow m-0">Welcome {user && user.first_name} !</p>
                            {user?.email && (
                                <small className="text-muted d-block text-overflow mt-1">
                                    {user.email}
                                </small>
                            )}
                            <span className={`${kycStatusDetails.badgeClassName} mt-2`}>
                                {kycStatusDetails.label}
                            </span>
                        </DropdownItem>


                        <DropdownItem onClick={handleMyAccount} className="noti-item">
                            <i className="remixicon-account-circle-line"/>
                            <span>Account</span>
                        </DropdownItem>

                        <DropdownItem onClick={handleSettings} className="noti-item">
                            <i className="remixicon-settings-3-line"/>
                            <span>Settings</span>
                        </DropdownItem>

                        <DropdownItem onClick={handleBilling} className="noti-item">
                            <i className="remixicon-bill-line"/>
                            <span>Billing</span>
                        </DropdownItem>

                        {/*<DropdownItem className="noti-item">*/}
                        {/*    <i className="remixicon-wallet-line"/>*/}
                        {/*    <span>Billing <span className="badge badge-success float-right">3</span> </span>*/}
                        {/*</DropdownItem>*/}

                        <DropdownItem divider />

                        <DropdownItem onClick={handleLogout} className="noti-item">
                            <i className="remixicon-logout-box-line"/>
                            <span>Logout</span>
                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>


            </ul>

            <div className="logo-box">
                <NavLink to={'/'} className="logo">
                    <span className="logo-lg logo-shift">
                        <img src={Logo} alt="" height="50"/>
                    </span>
                    <span className="logo-sm logo-shift">
                        <img src={Logo} alt="BlackX" height="30"/>
                    </span>
                </NavLink>
            </div>

            <ul className="list-unstyled topnav-menu topnav-menu-left m-0">
                <li>
                    <button className="button-menu-mobile waves-effect waves-light" onClick={handleSidebarToggle}>
                        <i className="fe-menu"/>
                    </button>
                </li>
            </ul>

        </div>
    );
}

export default Navbar;
